document.addEventListener('DOMContentLoaded', function() {
  
  // ==========================================
  // CART AJAX OPERATIONS
  // ==========================================

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
  }

  window.updateCartUI = function() {
    const url = new URL(window.location.href); url.searchParams.set('_t', Date.now()); return fetch(url.toString())
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Update Drawer Content
        const newDrawer = doc.getElementById('cart-drawer');
        const oldDrawer = document.getElementById('cart-drawer');
        if (newDrawer && oldDrawer) {
          oldDrawer.innerHTML = newDrawer.innerHTML;
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }

        // Update Cart Count
        const newCount = doc.querySelector('.cart-count');
        const oldCount = document.querySelector('.cart-count');
        if (oldCount) {
          if (newCount) {
            oldCount.textContent = newCount.textContent;
            oldCount.classList.remove('hidden');
            oldCount.classList.add('animate-ping', 'duration-75');
            setTimeout(() => oldCount.classList.remove('animate-ping', 'duration-75'), 300);
          } else {
             // If new page doesn't have it (hidden), hide it
             oldCount.classList.add('hidden');
             oldCount.textContent = '0';
          }
        }
      });
  }

  function changeCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(key), quantity: qty })
    })
    .then(response => response.json())
    .then(cart => {
      updateCartUI();
    })
    .catch(error => console.error('Error updating cart:', error));
  }

  // Event delegation for cart controls
  document.addEventListener('click', function(e) {
    const qtyPlus = e.target.closest('.ajax-qty-plus');
    const qtyMinus = e.target.closest('.ajax-qty-minus');
    const removeBtn = e.target.closest('.ajax-remove');
    
    if (qtyPlus) {
      e.preventDefault();
      changeCartItem(qtyPlus.dataset.key, qtyPlus.dataset.qty);
    }
    
    if (qtyMinus) {
      e.preventDefault();
      changeCartItem(qtyMinus.dataset.key, qtyMinus.dataset.qty);
    }
    
    if (removeBtn) {
      e.preventDefault();
      changeCartItem(removeBtn.dataset.key, 0);
    }
  });


  // ==========================================
  // QUICK ADD MODAL
  // ==========================================

  const qaModal = document.getElementById('quick-add-modal');
  const qaContent = document.getElementById('quick-add-content');
  const qaTitle = document.getElementById('qa-title');
  const qaPrice = document.getElementById('qa-price');
  const qaOldPrice = document.getElementById('qa-old-price');
  const qaImage = document.getElementById('qa-image');
  const qaOptionsContainer = document.getElementById('qa-options-container');
  const qaConfirmBtn = document.getElementById('qa-confirm-btn');
  const qaProductLink = document.getElementById('qa-product-link');
  const qaErrorMsg = document.getElementById('qa-error-message');
  
  let currentQaProduct = null;
  let currentQaOptions = [];

  function resolveColorSwatch(colorName) {
    const normalized = colorName.toLowerCase().trim().replace(/[-_]/g, ' ').replace(/\s+/g, ' ');
    switch (normalized) {
      case 'black': return '#000000';
      case 'white': return '#FFFFFF';
      case 'off white': case 'ivory': case 'cream': return '#FDFBF7';
      case 'nude': case 'skin': case 'natural': return '#E5D3C5';
      case 'beige': case 'sand': case 'tan': return '#D4C5B9';
      case 'brown': return '#6B4A31';
      case 'light brown': case 'camel': case 'khaki': return '#C19A6B';
      case 'dark brown': case 'chocolate': return '#3B2518';
      case 'coffee': case 'mocha': return '#4B3621';
      case 'light coffee': return '#70543E';
      case 'dark coffee': return '#2E1A11';
      case 'red': return '#C82128';
      case 'dark red': case 'wine red': case 'burgundy': case 'maroon': return '#722F37';
      case 'pink': case 'rose': return '#FFC0CB';
      case 'light pink': case 'baby pink': return '#F4C2C2';
      case 'hot pink': return '#FF69B4';
      case 'green': return '#4CAF50';
      case 'light green': return '#90EE90';
      case 'dark green': return '#006400';
      case 'army green': case 'olive': return '#4B5320';
      case 'blue': return '#2196F3';
      case 'light blue': return '#ADD8E6';
      case 'dark blue': case 'navy blue': return '#000080';
      case 'gray': case 'grey': return '#808080';
      case 'light gray': case 'light grey': return '#D3D3D3';
      case 'dark gray': case 'dark grey': return '#A9A9A9';
      case 'purple': return '#800080';
      case 'lavender': return '#E6E6FA';
      case 'yellow': return '#FFEB3B';
      case 'mustard': return '#FFDB58';
      case 'orange': return '#FF9800';
      case 'apricot': return '#FBCEB1';
      default:
        if (normalized.includes('blue')) return '#2196F3';
        if (normalized.includes('green')) return '#4CAF50';
        if (normalized.includes('red')) return '#C82128';
        if (normalized.includes('pink')) return '#FFC0CB';
        if (normalized.includes('brown')) return '#6B4A31';
        if (normalized.includes('grey') || normalized.includes('gray')) return '#808080';
        return '#E5E7EB';
    }
  }

  window.closeQuickAdd = function() {
    if(!qaModal) return;
    qaModal.classList.remove('opacity-100', 'pointer-events-auto');
    qaModal.classList.add('opacity-0', 'pointer-events-none');
    qaContent.classList.remove('translate-y-0', 'md:scale-100');
    qaContent.classList.add('translate-y-full', 'md:translate-y-4', 'md:scale-95');
  };

  function updateQaPrices(variant) {
    if(!variant) return;
    qaPrice.textContent = formatMoney(variant.price);
    if(variant.compare_at_price > variant.price) {
      qaOldPrice.textContent = formatMoney(variant.compare_at_price);
    } else {
      qaOldPrice.textContent = '';
    }
  }

  function renderQaOptions() {
    if (!qaOptionsContainer) return;
    qaOptionsContainer.innerHTML = '';
    
    if (!currentQaProduct.options || currentQaProduct.options.length === 0) {
      return; // No options
    }

    currentQaProduct.options.forEach((option, index) => {
      const isColor = (option.name.toLowerCase() === 'color' || option.name.toLowerCase() === 'colour' || option.name.toLowerCase() === 'couleur');
      let html = `<div class="qa-option-group" data-index="${index}">`;
      
      if (isColor) {
        html += `<div class="flex justify-between text-sm font-body-md mb-3">
                   <span class="text-espresso/70">${option.name}: <span class="text-espresso font-bold qa-selected-val">${currentQaOptions[index]}</span></span>
                 </div>
                 <div class="flex flex-wrap gap-3 mb-6">`;
                 
        option.values.forEach(val => {
          const activeClass = (val === currentQaOptions[index]) ? 'ring-2 ring-offset-2 ring-espresso border-espresso' : 'border-espresso/10';
          const resolvedColor = resolveColorSwatch(val);
          html += `<button type="button" class="qa-opt-btn qa-color-btn w-8 h-8 rounded-full border transition-all ${activeClass}" style="background-color: ${resolvedColor};" data-value="${val.replace(/"/g, '&quot;')}"></button>`;
        });
        html += `</div>`;
      } else {
        html += `<div class="flex justify-between text-sm font-body-md mb-3">
                   <span class="text-espresso/70">${option.name}: <span class="text-espresso font-bold qa-selected-val">${currentQaOptions[index]}</span></span>
                 </div>
                 <div class="flex flex-wrap gap-2 mb-6">`;
                 
        option.values.forEach(val => {
          const activeClass = (val === currentQaOptions[index]) ? 'border-espresso bg-espresso text-ivory' : 'border-espresso/20 text-espresso/70 hover:border-espresso hover:text-espresso';
          html += `<button type="button" class="qa-opt-btn py-2 px-4 border text-xs font-button transition-colors rounded-sm ${activeClass}" style="min-width: 60px;" data-value="${val.replace(/"/g, '&quot;')}">${val}</button>`;
        });
        html += `</div>`;
      }
      
      html += `</div>`;
      qaOptionsContainer.innerHTML += html;
    });

    // Attach listeners
    qaOptionsContainer.querySelectorAll('.qa-opt-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const group = this.closest('.qa-option-group');
        const idx = parseInt(group.dataset.index);
        const val = this.dataset.value;
        
        currentQaOptions[idx] = val;
        
        // Re-render to update classes
        renderQaOptions();
        
        // Find variant
        const variant = currentQaProduct.variants.find(v => {
          return v.options.every((opt, i) => opt === currentQaOptions[i]);
        });
        
        if (variant) {
          updateQaPrices(variant);
          
          if (variant.featured_image && variant.featured_image.src && qaImage) {
            let src = variant.featured_image.src;
            src = src.replace(/\.(png|jpg|jpeg|gif|webp)(\?.*)?$/i, '_400x.$1$2');
            qaImage.style.opacity = '0.5';
            const newImg = new Image();
            newImg.onload = function() {
              qaImage.src = src;
              qaImage.style.opacity = '1';
            };
            newImg.onerror = function() {
              qaImage.src = variant.featured_image.src;
              qaImage.style.opacity = '1';
            };
            newImg.src = src;
          }

          if(variant.available) {
             qaConfirmBtn.removeAttribute('disabled');
             qaConfirmBtn.querySelector('.btn-text').textContent = 'Add to Bag';
          } else {
             qaConfirmBtn.setAttribute('disabled', 'disabled');
             qaConfirmBtn.querySelector('.btn-text').textContent = 'Sold Out';
          }
        }
      });
    });
  }

  function quickAddHandler(e) {
    e.preventDefault();
    const dataNode = this.parentElement.querySelector('.product-data-json');
    if(!dataNode) return;
    
    try {
      currentQaProduct = JSON.parse(dataNode.textContent);
    } catch(err) {
      console.error(err);
      return;
    }

    // Set initial UI
    if(qaTitle) qaTitle.textContent = currentQaProduct.title;
    if(qaProductLink) qaProductLink.href = currentQaProduct.url;
    if(qaImage) qaImage.src = currentQaProduct.image || '';
    if(qaErrorMsg) qaErrorMsg.classList.add('hidden');
    
    qaConfirmBtn.removeAttribute('disabled');
    qaConfirmBtn.querySelector('.btn-text').textContent = 'Add to Bag';
    
    if (currentQaProduct.variants && currentQaProduct.variants.length > 0) {
      // Default to first available variant
      const firstAvailable = currentQaProduct.variants.find(v => v.available) || currentQaProduct.variants[0];
      currentQaOptions = [...firstAvailable.options];
      updateQaPrices(firstAvailable);
      if(!firstAvailable.available) {
         qaConfirmBtn.setAttribute('disabled', 'disabled');
         qaConfirmBtn.querySelector('.btn-text').textContent = 'Sold Out';
      }
    } else {
      currentQaOptions = [];
      qaPrice.textContent = formatMoney(currentQaProduct.price);
      if(currentQaProduct.compare_at_price > currentQaProduct.price) {
        qaOldPrice.textContent = formatMoney(currentQaProduct.compare_at_price);
      } else {
        qaOldPrice.textContent = '';
      }
    }

    renderQaOptions();
    
    if(qaModal && qaContent) {
      qaModal.classList.remove('opacity-0', 'pointer-events-none');
      qaModal.classList.add('opacity-100', 'pointer-events-auto');
      qaContent.classList.remove('translate-y-full', 'md:translate-y-4', 'md:scale-95');
      qaContent.classList.add('translate-y-0', 'md:scale-100');
    }
  }

  // Bind dynamically to support ajax loaded cards (using capture phase to beat stopPropagation)
  document.addEventListener('click', function(e) {
    if(e.target.classList.contains('quick-add-btn')) {
       quickAddHandler.call(e.target, e);
    }
  }, true);

  if(qaConfirmBtn) {
    qaConfirmBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if(this.classList.contains('adding')) return;
      
      let variantId = null;
      if (currentQaProduct.variants && currentQaProduct.variants.length > 0) {
        const variant = currentQaProduct.variants.find(v => {
          return v.options.every((opt, i) => opt === currentQaOptions[i]);
        });
        if(variant) variantId = variant.id;
      } else {
        variantId = currentQaProduct.variants[0].id; // fallback
      }

      if(!variantId) return;

      this.classList.add('adding');
      if(qaErrorMsg) qaErrorMsg.classList.add('hidden');
      
      const text = this.querySelector('.btn-text');
      const spinner = this.querySelector('.spinner-icon');
      const check = this.querySelector('.check-icon');
      
      text.style.opacity = '0';
      text.style.transform = 'translateY(-100%)';
      spinner.style.opacity = '1';
      spinner.style.transform = 'translateY(0)';
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(response => {
        if(!response.ok) throw new Error('Sold out or unavailable');
        return response.json();
      })
      .then(item => {
        updateCartUI().then(() => {
          spinner.style.opacity = '0';
          spinner.style.transform = 'translateY(-100%)';
          check.style.opacity = '1';
          check.style.transform = 'translateY(0)';
          this.classList.add('bg-terracotta', 'text-ivory');
          this.classList.remove('bg-espresso', 'text-ivory');
          
          setTimeout(() => {
            closeQuickAdd();
            setTimeout(() => {
              const cartDrawer = document.getElementById('cart-drawer');
              if(cartDrawer) cartDrawer.classList.remove('translate-x-full');
            }, 300);
            
            setTimeout(() => {
              check.style.opacity = '0';
              check.style.transform = 'translateY(100%)';
              text.style.opacity = '1';
              text.style.transform = 'translateY(0)';
              spinner.style.transform = 'translateY(100%)';
              this.classList.remove('bg-terracotta', 'adding');
              this.classList.add('bg-espresso');
            }, 1000);
            
          }, 600);
        });
      })
      .catch(error => {
        spinner.style.opacity = '0';
        spinner.style.transform = 'translateY(-100%)';
        text.style.opacity = '1';
        text.style.transform = 'translateY(0)';
        this.classList.remove('adding');
        if(qaErrorMsg) {
          qaErrorMsg.textContent = "Item cannot be added.";
          qaErrorMsg.classList.remove('hidden');
        }
      });
      
    });
  }

});

  // ==========================================
  // PREDICTIVE SEARCH
  // ==========================================
  const searchInput = document.getElementById('search-drawer-input');
  const searchResults = document.getElementById('search-drawer-results');
  const searchSuggested = document.getElementById('search-drawer-suggested');
  const searchSpinner = document.getElementById('search-drawer-spinner');
  
  let searchTimeout = null;
  let currentSearchController = null;

  if (searchInput) {
    searchInput.addEventListener('input', function() {
      const query = this.value.trim();
      
      clearTimeout(searchTimeout);
      
      if (currentSearchController) {
        currentSearchController.abort();
      }

      if (query.length === 0) {
        searchResults.classList.add('hidden');
        searchSuggested.classList.remove('hidden');
        searchSpinner.style.opacity = '0';
        return;
      }
      
      searchSpinner.style.opacity = '1';

      searchTimeout = setTimeout(() => {
        currentSearchController = new AbortController();
        
        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,page,collection&resources[limit]=4`, {
          signal: currentSearchController.signal
        })
        .then(response => response.json())
        .then(data => {
          searchSpinner.style.opacity = '0';
          renderPredictiveResults(data, query);
        })
        .catch(error => {
          if (error.name === 'AbortError') return;
          searchSpinner.style.opacity = '0';
          console.error(error);
        });
      }, 300); // 300ms debounce
    });
  }

  function renderPredictiveResults(data, query) {
    if (!searchResults) return;
    
    let html = '';
    const products = data.resources.results.products;
    const collections = data.resources.results.collections;
    const pages = data.resources.results.pages;
    
    const hasResults = (products.length > 0 || collections.length > 0 || pages.length > 0);
    
    if (!hasResults) {
      html = `
        <div class="text-center py-8">
          <p class="font-body-md text-secondary mb-2">No results found for "${query}"</p>
          <p class="text-sm text-espresso/70">Check your spelling or try a different term.</p>
        </div>
      `;
    } else {
      // Products
      if (products.length > 0) {
        html += `<h3 class="font-label-caps text-xs uppercase tracking-widest text-espresso mb-4">Products</h3>`;
        html += `<div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">`;
        products.forEach(product => {
          html += `
            <a href="${product.url}" class="flex gap-4 group p-2 hover:bg-surface transition-colors rounded-sm border border-transparent hover:border-espresso/10">
              <div class="w-16 h-20 bg-surface relative overflow-hidden rounded-sm shrink-0 border border-espresso/5">
                ${product.image ? `<img src="${product.image}" class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />` : ''}
              </div>
              <div class="flex flex-col justify-center">
                <span class="font-button text-sm font-bold text-espresso group-hover:underline underline-offset-2 leading-tight">${product.title}</span>
                <div class="flex items-center gap-2 mt-1">
                  <span class="font-body-md text-sm text-espresso font-medium">${product.price}</span>
                  ${(product.compare_at_price_min || product.compare_at_price_max || product.compare_at_price) && (product.compare_at_price_min || product.compare_at_price_max || product.compare_at_price) !== product.price ? `<span class="font-body-md text-xs text-espresso/40 line-through">${product.compare_at_price_min || product.compare_at_price_max || product.compare_at_price}</span>` : ''}
                </div>
              </div>
            </a>
          `;
        });
        html += `</div>`;
      }
      
      // Collections & Pages
      if (collections.length > 0 || pages.length > 0) {
        html += `<div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">`;
        
        if (collections.length > 0) {
          html += `<div>
            <h3 class="font-label-caps text-xs uppercase tracking-widest text-espresso mb-3">Collections</h3>
            <ul class="flex flex-col gap-2">`;
          collections.forEach(col => {
            html += `<li><a href="${col.url}" class="font-body-md text-sm text-secondary hover:text-espresso hover:underline underline-offset-2">${col.title}</a></li>`;
          });
          html += `</ul></div>`;
        }
        
        if (pages.length > 0) {
          html += `<div>
            <h3 class="font-label-caps text-xs uppercase tracking-widest text-espresso mb-3">Pages</h3>
            <ul class="flex flex-col gap-2">`;
          pages.forEach(page => {
            html += `<li><a href="${page.url}" class="font-body-md text-sm text-secondary hover:text-espresso hover:underline underline-offset-2">${page.title}</a></li>`;
          });
          html += `</ul></div>`;
        }
        html += `</div>`;
      }
      
      // View all
      html += `
        <div class="pt-4 border-t border-espresso/10 text-center">
          <a href="/search?q=${encodeURIComponent(query)}" class="inline-flex items-center gap-2 font-label-caps text-xs uppercase tracking-widest text-espresso hover:text-terracotta transition-colors">
            View all results for "${query}" <span class="material-symbols-outlined text-[14px]">arrow_forward</span>
          </a>
        </div>
      `;
    }
    
    searchResults.innerHTML = html;
    searchSuggested.classList.add('hidden');
    searchResults.classList.remove('hidden');
  }

  // Focus search input when drawer opens
  const searchTriggers = document.querySelectorAll('button[aria-label="Search"]');
  searchTriggers.forEach(btn => {
    btn.addEventListener('click', () => {
      setTimeout(() => {
        if (searchInput) searchInput.focus();
      }, 300); // Wait for transition
    });
  });

  // ==========================================
  // PRODUCT CARD COLOR SWATCHES
  // ==========================================
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('card-swatch')) {
      e.preventDefault(); // Just in case, though stopPropagation is on the element
      const swatch = e.target;
      const card = swatch.closest('.group');
      if (!card) return;

      const dataNode = card.querySelector('.product-data-json');
      if (!dataNode) return;

      let productData;
      try {
        productData = JSON.parse(dataNode.textContent);
      } catch (err) {
        console.error("Invalid product JSON", err);
        return;
      }

      const selectedColor = swatch.getAttribute('data-color');
      if (!selectedColor) return;

      // Update active state of swatches
      const swatches = card.querySelectorAll('.card-swatch');
      swatches.forEach(s => {
        s.classList.remove('ring-1', 'ring-offset-1', 'ring-espresso', 'is-active');
      });
      swatch.classList.add('ring-1', 'ring-offset-1', 'ring-espresso', 'is-active');

      // Find the color option index
      const colorOptionIndex = productData.options.findIndex(opt => {
        const name = (opt.name || opt).toString().toLowerCase();
        return name === 'color' || name === 'colour' || name === 'couleur';
      });
      
      if (colorOptionIndex === -1) return;

      // Find first variant that matches this color
      const matchingVariant = productData.variants.find(v => {
        // In the JSON output of product.variants, the options are in v.options (array of strings) or v.option1, v.option2
        // Shopify liquid {{ product.variants | json }} usually exposes option1, option2, option3
        const optKey = `option${colorOptionIndex + 1}`;
        return v[optKey] === selectedColor;
      });

      if (matchingVariant && matchingVariant.featured_image && matchingVariant.featured_image.src) {
        const imgEl = card.querySelector('.card-img');
        if (imgEl) {
          // Attempt to resize to 600x to save bandwidth, using Shopify URL replacement
          let src = matchingVariant.featured_image.src;
          
          // Shopify URL usually has ?v=, we need to insert _600x before the extension if possible.
          // A simple regex to inject _600x before .jpg, .png, .webp
          src = src.replace(/\.(png|jpg|jpeg|gif|webp)(\?.*)?$/i, '_600x.$1$2');
          
          // Smooth transition
          imgEl.style.opacity = '0.5';
          const newImg = new Image();
          newImg.onload = function() {
            imgEl.src = src;
            imgEl.style.opacity = '1';
          };
          newImg.onerror = function() {
            // Fallback to original
            imgEl.src = matchingVariant.featured_image.src;
            imgEl.style.opacity = '1';
          };
          newImg.src = src;
        }
      }

      // Update the parent card link to include the variant ID
      if (matchingVariant) {
        card.setAttribute('onclick', `window.location.href='${productData.url}?variant=${matchingVariant.id}'`);
      }
    }
  }, true); // use capture phase
